import { deleteCookie } from 'cookies-next/client';

import { COMBINED_FLOW_LAYOUT } from '@/constants/cookies';
import { isServerCheck } from '@/modules/env/isServerCheck';

export async function clearCombinedFlowCookie() {
  if (isServerCheck()) {
    const { cookies } = await import('next/headers');
    (await cookies()).delete(COMBINED_FLOW_LAYOUT);
    return;
  }

  deleteCookie(COMBINED_FLOW_LAYOUT, { path: '/' });
}
